import { isNaN } from 'lodash';
import { ChangeEvent, InputHTMLAttributes } from 'react';
import { Errors, FormErrorsProps } from 'react-form-reducer';

export function numeric(
  e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  inputProps: InputHTMLAttributes<HTMLInputElement> = {},
  toFixed?: number
) {
  const { min, max } = inputProps;

  const inputValue = e.target.value;

  const numericRegex = /^-?\d*\.?\d*$/;

  if (!numericRegex.test(inputValue)) {
    while (isNaN(Number(e.target.value)))
      e.target.value = e.target.value.slice(0, -1);
  } else {
    if (min !== undefined && min !== null && Number(inputValue) < Number(min)) {
      e.target.value = min.toString();
    } else if (
      max !== undefined &&
      max !== null &&
      Number(inputValue) > Number(max)
    ) {
      e.target.value = max.toString();
    } else if (
      inputValue !== '' &&
      inputValue !== '-' &&
      inputValue !== '.' &&
      inputValue.lastIndexOf('.') !== inputValue.length - 1
    )
      if (toFixed && inputValue.includes('.')) {
        const decimalLen = inputValue.split('.')[1].length;

        if (decimalLen > toFixed) {
          e.target.value = parseFloat(inputValue).toFixed(2);
        }
      } else {
        e.target.value = parseFloat(inputValue).toString();
      }
  }
}

export const handleApplicantErrors = (
  field: string,
  errors: FormErrorsProps<never>
) => {
  const errorKeyPrefix = field;
  const allErrors = errors?.all() || {};
  const filteredErrors: Errors = Object.entries(allErrors).reduce<Errors>(
    (acc, [key, messages]) => {
      if (key.startsWith(errorKeyPrefix)) {
        const trimmedKey = key.replace(`${errorKeyPrefix}.`, '');
        acc[trimmedKey] = messages as string[];
      }
      return acc;
    },
    {}
  );
  return {
    errors: filteredErrors,
    error: !!Object.keys(filteredErrors)?.length
  };
};
